import { render, staticRenderFns } from "./OrderPriceSummarySection.vue?vue&type=template&id=9432f0d6&"
import script from "./OrderPriceSummarySection.vue?vue&type=script&lang=ts&"
export * from "./OrderPriceSummarySection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports